import { Check } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

export default function Pricing() {
    const { t } = useI18n();
    const p = t.pricing;
    const HIGHLIGHTS = [false, true, false];
    return (
        <section
            id="pricing"
            data-testid="pricing-section"
            className="relative py-24 md:py-32 border-t border-white/5"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-8 mb-14 reveal">
                    <div className="lg:col-span-7">
                        <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#D4FF00] mb-4">
                            {p.tag}
                        </div>
                        <h2 className="font-display font-bold uppercase text-4xl md:text-5xl lg:text-6xl tracking-tighter heading-clamp">
                            {p.headline}{" "}
                            <span className="text-[#D4FF00]">{p.headlineAccent}</span>
                        </h2>
                    </div>
                    <div className="lg:col-span-5 self-end">
                        <p className="text-white/65 text-lg leading-relaxed">{p.sub}</p>
                    </div>
                </div>

                <div className="grid md:grid-cols-3 gap-5 md:gap-6">
                    {p.tiers.map((tier, i) => {
                        const highlight = HIGHLIGHTS[i];
                        return (
                            <div
                                key={tier.name}
                                data-testid={`pricing-tier-${i}`}
                                className={`card-hover relative rounded-2xl p-7 md:p-8 reveal ${
                                    highlight
                                        ? "bg-[#D4FF00] text-[#04140D] border-2 border-[#D4FF00] lime-glow"
                                        : "bg-[#071B12] text-white border border-white/10"
                                }`}
                                style={{ transitionDelay: `${i * 90}ms` }}
                            >
                                {highlight && (
                                    <span className="absolute -top-3 left-7 px-3 py-1 rounded-full bg-[#04140D] text-[#D4FF00] text-[10px] font-bold tracking-widest uppercase border border-[#D4FF00]/40">
                                        {p.popular}
                                    </span>
                                )}
                                <div
                                    className={`text-[11px] tracking-[0.22em] uppercase font-bold ${
                                        highlight ? "text-[#04140D]/70" : "text-[#D4FF00]"
                                    }`}
                                >
                                    {tier.name}
                                </div>
                                <div className="mt-4 flex items-end gap-2">
                                    <span className="font-display text-6xl md:text-7xl font-bold tabular leading-none tracking-tighter">
                                        {tier.price}
                                    </span>
                                    <span
                                        className={`pb-2 text-sm ${
                                            highlight ? "text-[#04140D]/70" : "text-white/55"
                                        }`}
                                    >
                                        {p.perMonth}
                                    </span>
                                </div>
                                <p
                                    className={`mt-3 text-sm leading-relaxed min-h-[50px] ${
                                        highlight ? "text-[#04140D]/80" : "text-white/65"
                                    }`}
                                >
                                    {tier.tagline}
                                </p>

                                <button
                                    data-testid={`pricing-cta-${i}`}
                                    className={`w-full mt-6 py-3.5 rounded-full font-bold transition-all hover:scale-[1.02] active:scale-[0.98] ${
                                        highlight
                                            ? "bg-[#04140D] text-[#D4FF00] hover:bg-[#0A2418]"
                                            : "bg-white text-[#04140D] hover:bg-[#D4FF00]"
                                    }`}
                                >
                                    {tier.cta}
                                </button>

                                <ul className="mt-7 space-y-3">
                                    {tier.features.map((f) => (
                                        <li key={f} className="flex items-start gap-3 text-[14px]">
                                            <Check
                                                size={16}
                                                className={`mt-0.5 flex-shrink-0 ${
                                                    highlight ? "text-[#04140D]" : "text-[#D4FF00]"
                                                }`}
                                            />
                                            <span
                                                className={
                                                    highlight ? "text-[#04140D]/90" : "text-white/80"
                                                }
                                            >
                                                {f}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
